/**
 * BIL Store Locator data helpers.
 * This module has no DOM dependencies.
 */
(function (window) {
  'use strict';

  var EARTH_RADIUS_MILES = 3958.8;

  function loadStores(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Store data could not be loaded (' + response.status + ').');
        }
        return response.json();
      })
      .then(function (data) {
        var stores = Array.isArray(data.stores) ? data.stores : [];
        return stores
          .filter(function (store) {
            return store && store.status === 'active';
          })
          .map(function (store) {
            return Object.assign({
              address_2: '',
              phone: '',
              geocoding_status: null
            }, store);
          });
      });
  }

  function hasCoordinates(store) {
    return typeof store.latitude === 'number' &&
      Number.isFinite(store.latitude) &&
      typeof store.longitude === 'number' &&
      Number.isFinite(store.longitude);
  }

  function distanceInMiles(lat1, lng1, lat2, lng2) {
    function radians(value) { return value * Math.PI / 180; }
    var dLat = radians(lat2 - lat1);
    var dLng = radians(lng2 - lng1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(radians(lat1)) * Math.cos(radians(lat2)) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return EARTH_RADIUS_MILES * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function detectSearchType(term) {
    var value = (term || '').trim();
    if (!value) return null;
    if (/^\d{5}(?:-\d{4})?$/.test(value)) return 'zip';
    if (/^[a-z]{2}$/i.test(value)) return 'state';
    return 'text';
  }

  function normalize(value) {
    return (value || '').toString().toLowerCase().trim();
  }

  // Customer-facing search is deliberately limited to ZIP, city, or state.
  function matchesText(store, term) {
    var needle = normalize(term);
    if (!needle) return true;

    return [
      store.city,
      store.state,
      store.zip
    ].some(function (value) {
      return normalize(value).indexOf(needle) !== -1;
    });
  }

  function filterByFacets(stores, filters) {
    filters = filters || {};
    return stores.filter(function (store) {
      return (!filters.state || normalize(store.state) === normalize(filters.state)) &&
        (!filters.region || normalize(store.region) === normalize(filters.region)) &&
        (!filters.retailer || normalize(store.retailer) === normalize(filters.retailer));
    });
  }

  function filterByText(stores, term) {
    return stores.filter(function (store) {
      return matchesText(store, term);
    });
  }

  function sortByDistance(stores, origin) {
    if (!origin || typeof origin.lat !== 'number' || typeof origin.lng !== 'number') {
      return stores.slice();
    }
    return stores.map(function (store) {
      return Object.assign({}, store, {
        distance_miles: hasCoordinates(store)
          ? distanceInMiles(origin.lat, origin.lng, store.latitude, store.longitude)
          : null
      });
    }).sort(function (left, right) {
      if (left.distance_miles === null && right.distance_miles === null) return 0;
      if (left.distance_miles === null) return 1;
      if (right.distance_miles === null) return -1;
      return left.distance_miles - right.distance_miles;
    });
  }

  function buildFilterOptions(stores) {
    function unique(field) {
      return Array.from(new Set(stores.map(function (store) {
        return store[field];
      }).filter(Boolean))).sort();
    }
    return {
      states: unique('state'),
      regions: unique('region'),
      retailers: unique('retailer')
    };
  }

  function fullAddress(store) {
    return [
      store.address_1,
      store.address_2,
      [store.city, store.state, store.zip].filter(Boolean).join(' ')
    ].filter(Boolean).join(', ');
  }

  window.BILStoreLocatorData = {
    loadStores: loadStores,
    hasCoordinates: hasCoordinates,
    distanceInMiles: distanceInMiles,
    detectSearchType: detectSearchType,
    filterByFacets: filterByFacets,
    filterByText: filterByText,
    sortByDistance: sortByDistance,
    buildFilterOptions: buildFilterOptions,
    fullAddress: fullAddress
  };
})(window);
